/**
 * useMissionHistoryCharts Hook
 * 
 * Provides chart data for Mission History page
 */

import { useMemo } from 'react';
import { MISSION_TYPE_CHART_DATA, MISSION_DURATION_CHART_DATA } from '../constants';

export const useMissionHistoryCharts = () => {
    const missionTypeChart = useMemo(() => MISSION_TYPE_CHART_DATA, []);
    const missionDurationChart = useMemo(() => MISSION_DURATION_CHART_DATA, []);

    return {
        missionTypeChart,
        missionDurationChart,
    };
};
